import React, {useEffect, useRef, useState} from 'react';
import {Select} from 'antd';
import {useTranslation} from 'react-i18next';
import api from '../api';
import useCurrentOrg from '../helpers/useCurrentOrg';

// Form-controlled names only: selecting a suggestion never writes to an asset.
export default function StandardTagFormSelect({value = [], onChange, subType, ...props}) {
    const {t} = useTranslation();
    const org = useCurrentOrg();
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);
    const generation = useRef(0);
    const context = useRef('');
    context.current = `${org?.id}:${subType}`;
    useEffect(() => {
        const request = ++generation.current;
        const scope = context.current;
        setResults([]);
        setFailed(false);
        setLoading(false);
        if (!query.trim() || !org?.id) return;
        const timer = setTimeout(() => {
            setLoading(true);
            api.get('/api/tags', {params: {list: 'visible', q: query, sub_type: subType}}).then(response => {
                if (request !== generation.current || scope !== context.current) return;
                setResults(Array.isArray(response.data) ? response.data : []);
            }).catch(() => {
                if (request === generation.current && scope === context.current) setFailed(true);
            }).finally(() => {
                if (request === generation.current && scope === context.current) setLoading(false);
            });
        }, 200);
        return () => { clearTimeout(timer); ++generation.current; };
    }, [query, org?.id, subType]);
    const names = [...new Set([...(value || []), ...results.map(tag => tag.name)])];
    return <Select {...props} mode="tags" allowClear value={value} onChange={onChange} filterOption={false}
        loading={loading} tokenSeparators={[',', ';']} onSearch={text => { ++generation.current; setQuery(text); }}
        onSelect={() => { ++generation.current; setQuery(''); setResults([]); }}
        options={names.map(name => ({value: name, label: name}))}
        notFoundContent={failed ? t('tag-search-failed', 'Suggestions unavailable. Try again.') : undefined}/>;
}
